import { ReactNode } from "react";
import { IMarkdownTable } from "../../../utilization/MarkdownTableUtilization";

/**
 * A markdown pipe table from an activity TEXT item, drawn as a real table. Cells are rendered by
 * the caller (`renderCell`) so **bold**, __underline__ and $$math$$ look exactly as they do in the
 * surrounding text. Text wraps inside a cell; a table still wider than its card scrolls sideways
 * in its own box instead of being clipped. Styles: `.med-tbl*` in mediaStyles.
 */
const MarkdownTable = ({
  table,
  renderCell,
}: {
  table: IMarkdownTable;
  renderCell: (text: string, key: string) => ReactNode;
}) => {
  const alignClass = (column: number) =>
    table.align[column] === "center" ? "med-tbl-c" : table.align[column] === "right" ? "med-tbl-r" : "";
  return (
    <div className="med-tbl-scroll">
      <table className="med-tbl">
        <thead>
          <tr>
            {table.header.map((cell, column) => (
              <th key={column} className={alignClass(column)}>
                {renderCell(cell, `h-${column}`)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {table.rows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {row.map((cell, column) => (
                <td key={column} className={alignClass(column)}>
                  {renderCell(cell, `r-${rowIndex}-${column}`)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MarkdownTable;
